import { ProgressOverviewButton } from "@components/progress-overview/progress-overview-button";
import { ProgressOverviewSection } from "@components/progress-overview/progress-overview-section";
import { InfoIcon, Popover, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useAppSelector } from "@store/store-helper";
import { hasIncompleteUploadTasksSelector, hasInProgressUploadTasksSelector } from "@store/upload-tasks/upload-tasks-selector";
import { ProgressOverviewEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useEffect, useRef, useState } from "react";

/** Renders a menu to track the upload progress */
export function ProgressOverviewMenu() {
  const {
    trackEvent
  } = useTrackEvent();
  const hasUploadTask = useAppSelector(hasIncompleteUploadTasksSelector);
  const hasInProgressUploadTask = useAppSelector(hasInProgressUploadTasksSelector);
  const [isOpen, setIsOpen] = useState(false);
  const button = useRef(null);
  useEffect(() => {
    if (!hasUploadTask) {
      setIsOpen(false);
    }
  }, [hasUploadTask]);

  /** Opens the progress overview menu */
  const handleClick = useCallback(ev => {
    if (!isOpen) {
      trackEvent({
        name: ProgressOverviewEvents.openProgressOverview
      });
      setIsOpen(true);
      ev.stopPropagation();
    }
  }, [isOpen, trackEvent]);
  return <>
      <ProgressOverviewButton ref={button} onClick={handleClick} isLoading={hasInProgressUploadTask} disabled={!hasUploadTask} />
      <Popover open={isOpen} anchorEl={button.current} onClose={() => setIsOpen(false)} placement="bottom" showCloseButton={false}
    // The content brings its own spacing
    sx={{
      "& .MuiPaper-root": {
        p: 0
      }
    }}>
        <Stack component="div" sx={{
        width: "100%",
        maxWidth: "400px",
        maxHeight: "550px",
        borderRadius: "5px",
        p: 0,
        my: 4,
        overflow: "hidden"
      }} data-testid="progress-overview-menu">
          <Text variant="heading16" sx={{
          mx: "32px"
        }}>
            Uploads
          </Text>

          <ProgressOverviewSection />

          <Stack sx={{
          flexDirection: "row",
          pt: 2,
          mx: 4,
          alignItems: "flex-start"
        }}>
            <InfoIcon sx={{
            color: "warning.main",
            pt: 0.3,
            height: "16px"
          }} />
            <Text variant="bodyS" sx={{
            color: "text.secondary"
          }}>
              Progress will be lost only if you close the browser while
              uploading your files.
            </Text>
          </Stack>
        </Stack>
      </Popover>
    </>;
}